import React, { useState } from "react";
import axios from "axios";
import career from "../../images/career.svg";
import { FaPhoneSquareAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";
import Grow from "../../images/grow-your-career.png";
import Shape from "../../images/shape-global.png";
import Buissness from "../../images/drive-business-growth.png";
import { BASE } from "../../App.js";
import yes from "../../images/yes.svg";
import "./career.scss";
import { useRef } from "react";
import { useEffect } from "react";
import Loading from "../../components/loading/Loading.jsx";
import LoadingForm from "../../components/loading/LoadingForm.jsx";
import Logos from "../../images/logo.png"

const Career = () => {
  const [full_name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [wh_num, setWh_num] = useState("");
  const [file, setFile] = useState(null);

  const [sending, setSending] = useState(false);
  const [sent, setsent] = useState(false);
  const [err, seterr] = useState({});
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setsent(false);
    seterr({});
    if (!file) {
      console.error("Please upload an email file");
      return;
    }
    const formData = new FormData();
    formData.append("full_name", full_name);
    formData.append("resume", file);
    formData.append("email", email);
    formData.append("wh_num", wh_num);
    try {
      const response = await axios.post(`${BASE}/career/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setSending(false);
      setsent(true);
      setEmail("");
      setWh_num("");
      setName("");
      setFile(null);
    } catch (error) {
      seterr(error.response.data);
      setSending(false);
      console.error("Error sending data:", error);
    }
  };
  
  const [fileName, setFileName] = useState("No file chosen");

  const handleFileChanges = (event) => {
    if (event.target.files.length > 0) {
      setFileName(event.target.files[0].name);
    } else {
      setFileName("No file chosen");
    }
  };

 
 const formRef = useRef(null);

  const handleScroll = () => {
    if (formRef.current) {

      const y =
        formRef.current.getBoundingClientRect().top +
        window.pageYOffset -
        100;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  console.log(sending);
  return (
    <div className="career_cont">
      <div className="career_back_top">
        <div className="cp_left_title">

          <h1>Careers at TradeFlair</h1>
          <h3>Build a Career in Global Trade Finance</h3>
          <p>
            At TradeFlair, we offer career opportunities for professionals looking to grow in the global trade finance industry.
             Explore roles across sales, operations, risk, compliance, and partnerships while gaining hands-on exposure to 
             international trade finance solutions.
          </p>
        </div>
      </div>
      <div className="career_hero">
        <div className="career_hero_text">
          <h2>Join Our Trade Finance Team</h2>
          <p>
            At TradeFlair, we are building a high-performance team shaping the future of global trade finance.
             Work on real international transactions, collaborate with leading banks, and gain hands-on exposure across
              sales, operations, risk, and partnerships. If you're driven, growth-oriented, and ready to make an
               impact in cross-border trade, your journey starts here.
          </p>
          <button onClick={handleScroll}>Join Us Now!</button>
        </div>
      </div>
      <div className="career_subTitle">
        <h2>Our Mission: Powering Global Trade with Confidence</h2>
        <p>
         At TradeFlair, our mission is to simplify global trade by delivering reliable, structured trade finance solutions. We empower
          businesses with access to strong banking networks, flexible financing options, and expert execution support to enable smooth, 
          secure, and sustainable international trade growth.

        </p>
      </div>
      <div className="career_why">
        <h2>Why Join TradeFlair?</h2>
        <div className="career_why_divs">
          <div className="career_why_div">
            <img src={Shape} alt="" className="team_svg" />
            <h3>Shape Global Trade Finance</h3>
            <p>
              Work on impactful trade finance solutions for importers, exporters, and banks.
            </p>
          </div>
          <div className="career_why_div">
            <img src={Grow} alt="" className="money_svg" />
            <h3>Drive Business Growth</h3>
            <p>
              Help businesses succeed through secure and efficient trade finance.
            </p>
          </div>
          <div className="career_why_div">
            <img src={Buissness} alt="" className="hit_svg" />
            <h3>Grow Your Career</h3>
            <p>
              Build a rewarding career with strong growth and industry exposure.
            </p>
          </div>
        </div>
      </div>
      <div className="career_form">
        <div className="address_contents">
            <div className="contact_left">
                      <div className="contact_title">
                        <h3>Start Your Career Journey with TradeFlair</h3>
                        <p>Looking for opportunities in trade finance? Contact us to explore current openings and career paths at TradeFlair.</p>
                      </div>
                      <div className="contact_info">
                        <div className="contact_info_div">
                          <FaPhoneSquareAlt className="contact_icon" />
                          <p>+91 9810911531</p>
                        </div>
                        <div className="contact_info_div">
                          <IoMail className="contact_icon" />
                          <p>sales@tradeflaircorporate.com</p>
                        </div>
                        <div className="contact_info_div">
                          <FaLocationDot className="contact_icon" />
                          <p>
                            1st Floor, G-31, Block G, Sector 3, Noida 201301, India
                          </p>
                        </div>
                   </div>
              </div>
        </div>
        {/* <img src={career} alt="" /> */}
        <form className="" onSubmit={handleSubmit} ref={formRef}>
          <div className="logos_divisions">
            <img src={Logos} alt=""/>
            <h3>Join Us Now!</h3>
          </div>
          <div className="career_form_div">
            <input
              type="text"
              name=""
              placeholder="Full Name"
              id=""
              required
              value={full_name}
              onChange={(e) => setName(e.currentTarget.value)}
            />
          </div>
          <div className={`career_form_div`}>
            <input
              type="text"
              placeholder="Email"
              name=""
              id=""
              required
              value={email}
              className={"email" in err && "outline_red"}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
            {"email" in err && <p className="career_error_m">{err.email} </p>}
          </div>
          <div className="career_form_div">
            <input
              type="number"
              placeholder="Phone Number"
              name=""
              id=""
              required
              value={wh_num}
              className={"wh_num" in err && "outline_red"}
              onChange={(e) => setWh_num(e.currentTarget.value)}
            />
            {"wh_num" in err && <p className="career_error_m">{err.wh_num} </p>}
          </div>
           <div className="file-upload">
            <input
              type="file"
              id="fileInput"
              onChange={handleFileChanges}
            />
            <label htmlFor="fileInput" className="custom-file-btn">
              Upload File
            </label>
            <span className="file-name">{fileName}</span>
          </div>
          <div className="career_loading">
            <button type="submit">Send</button>
            {sending && <LoadingForm />}
            {sent && <img src={yes} alt="" className="contact_sent" />}
          </div>
        </form>
      </div>
    </div>
  );
};

export default Career;
